import { Injectable } from '@angular/core';
import { ErrorDialogService } from '../error-dialog.service';
import { DialogResult } from '../../../models/dialog/dialog-result.model';
import { DialogButton } from '../../../enums/dialog-button.enum';

/**
 * A service to mock the confirm dialog service
 */
@Injectable({
  providedIn: 'root'
})
export class MockErrorDialogService extends ErrorDialogService {
  /**
   * Open an error dialog
   * @param title - The title of the error dialog
   * @param message - The message to display to the user
   */
  public async openErrorDialog(
    title: string,
    message: string
  ): Promise<DialogResult<null>> {
    console.log('Using mock error dialog service.');
    console.log('Title: ' + title);
    console.log('Title: ' + message);
    return Promise.resolve(new DialogResult<null>(DialogButton.OK));
  }
}
